/**
 * @file Entry for starting app on <div id="app"></div>
 */

import './setup'
import './theme/reader.scss'
import Vue from 'vue'
import App from './components/App.vue'

new Vue({
  render: h => h(App),
}).$mount('#app')
